/* eslint-disable @typescript-eslint/no-explicit-any */
import registerContactUsClick from './registerContactUsClick';
import registerHubspotFormStart from './registerHubspotFormStart';
import registerHubspotFormSubmit from './registerHubspotFormSubmit';

export const eventListeners = {
  registerContactUsClick,
  registerHubspotFormStart,
  registerHubspotFormSubmit,
};

export const initialize = () => {
  if (!window) return;

  (window as any).dataLayer ||= [];
  (window as any).gtmEventTracker ||= eventListeners;

  registerContactUsClick();
};

const gtmEventTracker = {
  initialize,
  ...eventListeners,
};

export default gtmEventTracker;
